import clsx from 'clsx';
import type { PropsWithChildren } from 'react';

import { MultiMeterBarChartOverlayWithTooltip } from './MultiMeterBarChartOverlayWithTooltip.js';
import { Flex } from '../../../../../layouts/flex/Flex.js';
import { useMeterBarChartLoading } from '../../../shared/context/MeterBarChartLoadingContext.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSizeContext.js';
import { elementSize } from '../../../shared/styles/element-size.sty.js';
import { container } from '../../../shared/styles.sty.js';
import { useMultiMeterBarChartTooltipData } from '../../context/MultiMeterBarChartTooltipContext.js';

export const MultiMeterBarChartOverlay = ({ children }: PropsWithChildren) => {
  const { size } = useMeterBarLayoutSize();
  const { tooltipConfig } = useMultiMeterBarChartTooltipData();
  const loading = useMeterBarChartLoading();

  if (!tooltipConfig.enabled || loading) {
    return (
      <Flex
        className={clsx(container, elementSize({ size }))}
        data-testid="overlay-wrapper"
      >
        {children}
      </Flex>
    );
  }

  return (
    <MultiMeterBarChartOverlayWithTooltip>
      {children}
    </MultiMeterBarChartOverlayWithTooltip>
  );
};
